//
//  Tile is used to for cart items and order items on checkout and checkout summary views
//
import { Component, ChangeDetectionStrategy, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-tile-for-cart',
    templateUrl: './tile-for-cart.shared.component.html',
    styleUrls: ['./tile-for-cart.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileForCartComponent extends TilesComponent implements OnInit {
    public isMenuFlow: boolean = false;
    public title: string;
    @Input() public cartItem: State.ICartMenuFlow & State.ICartSimpleItem;

    public quantity$: Observable<number>;
    public total$: Observable<number>;
    public description$: Observable<string>;
    public specialInstructions$: Observable<string>;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
        private _modalsService: Services.ModalsService,
        private _cartService: Services.CartService) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        this.isMenuFlow = !!this.cartItem?.MenuFlowId;
        this.title = this.controllers.cart.cartItemTitle(this.cartItem);

        this.quantity$ = this.controllers.cart.cartItemTotalQuantity$(this.cartItem);
        this.total$ = this.controllers.cart.cartItemTotalValue$(this.cartItem);
        this.description$ = this.controllers.cart.cartItemDescription(this.cartItem);
        this.specialInstructions$ = this.controllers.cart.cartItemSpecialInstructions(this.cartItem);
    }

    public handleIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        return this.controllers.cart.incrementCartItem(this.cartItem);
    }

    public handleDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        return this.controllers.cart.decrementCartItem(this.cartItem);
    }

    public handleRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        return this.controllers.cart.decrementCartItem(this.cartItem);
    }

    public handleEdit($event: Event): void {
        this._modalsService.closeAll();
        this._cartService.hidePopup();

        return this.controllers.cart.editCartItem(this.cartItem);
    }
}
